import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { Form, Text, Number } from 'components/forms'
import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'

import globalStyles from 'style/app.module.scss'

const External = ({ formData, mutations: { updateItem }, newRecord }) => {
	const [t] = useTranslation()

	return(
		<Form
			smartSubmit
			initialValues={formData}
			onSubmit={updateItem}
			className={globalStyles['flex-cols']}
		>
			{() => {
				return(
					<ExpandableBlocks>
						<ContentBlock alwaysExpanded>
							<Row>
								<Col xs>
									<Number field='clientNumber' label={t('options_section.fields.client_number_extern')}/>
									<Number field='filial' label={t('options_section.fields.filial_extern')}/>
									<Text field='externToolBox' label={t('options_section.fields.toolbox_extern')} />
								</Col>
							</Row>
						</ContentBlock>
					</ExpandableBlocks>
				)
			}}
		</Form>
	)
}

export default External
